export default __webpack_public_path__ + "static/media/table_mockup_fill_0_seats.fe67026a.png";